import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import GroupedMultiSelect from "./grouped_multi_select";

class WrappedGroupedMultiSelect extends React.Component {
  render () {
    const classes = Object.assign({}, { "form-group": true }, this.props.extraHtmlClasses);
    return (
      <div className={classNames(classes)}>
        <h4 onClick={ () => this.inputWrapper.input.focus() }>{this.props.title}</h4>
        <GroupedMultiSelect
          ref={(inputWrapper) => this.inputWrapper = inputWrapper }
          selectedValues={this.props.selectedValues}
          values={this.props.values}
          onChange={this.props.onChange}
          clearable={this.props.clearable}

          placeholder={this.props.placeholder}

          onInputChange={this.props.onInputChange}
          initialTextValue={this.props.initialTextValue}
          disabled={this.props.disabled}
        />
      </div>
    );
  }
}

WrappedGroupedMultiSelect.propTypes = Object.assign({}, GroupedMultiSelect.propTypes, {
  title: PropTypes.string.isRequired,
  extraHtmlClasses: PropTypes.object.isRequired
});

export default WrappedGroupedMultiSelect;
